import type { Role } from '@repo/api-gw-sdk';

import { Wizard } from '@/components/wizard/Wizard';

import {
  UpsertCustomRoleFlow,
  type UpsertCustomRoleState,
} from './upsertCustomRoleFlow';

interface UpsertRoleSidePanelProps {
  entity: Role;
  onSave: (role: Role) => Promise<void>;
  onAbort: () => void;
}

export function CustomRolePanel(props: UpsertRoleSidePanelProps) {
  const save = async (state: UpsertCustomRoleState) => {
    await props.onSave(state);
    return true;
  };

  return (
    <Wizard<UpsertCustomRoleState>
      hideBackArrow={true}
      onAbort={props.onAbort}
      onFinish={save}
      initialStep={{ stepIndex: props.entity.id ? 1 : 0 }}
      flow={[UpsertCustomRoleFlow]}
      initialState={{
        ...props.entity,
      }}
      title={
        props.entity.id
          ? `Edit ${props.entity.isProjectRole ? 'Project' : 'Global'} Role`
          : `Create ${props.entity.isProjectRole ? 'Project' : 'Global'} Role`
      }
    />
  );
}
